import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import apiClient from "../utils/axios";
import { ADMIN, COMMON } from "../config/api";
import toast from "react-hot-toast";

function Menu() {
  const [dishes, setDishes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState(""); // for showing success/error messages

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const editId = queryParams.get("id"); // null = Add, string = Edit
    const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchMenu = async () => {
      try {
        const { data } = await apiClient.get(ADMIN.GET_MENU);
        if (data.success) {
          setDishes(data.items);
        }
      } catch (err) {
        console.error("Error fetching menu:", err);
        toast.error(err.response?.data?.message || err.message || "Failed to fetch menu items");
      } finally {
        setLoading(false);
      }
    };

    fetchMenu();
  }, []);

  const handleDelete = async (id) => {
  if (!id) return;

  const confirmDelete = window.confirm("Are you sure you want to delete this item?");
  if (!confirmDelete) return;

  setLoading(true);
  setMessage("");

  try {
    const { data } = await apiClient.delete(ADMIN.DELETE_MENU(id));
    if (!data.success) throw new Error(data?.message || "Delete failed");

    toast.success(data.message || "Item deleted successfully");
    setDishes((prev) => prev.filter((dish) => dish._id !== id));
  } catch (err) {
    toast.error(err.response?.data?.message || err.message || "Failed to delete item");
  } finally {
    setLoading(false);
  }
};



  return (
    < >
      <div className="main-content flex-grow-1">
        <div className=" d-flex justify-content-between">
          <div>
            <h3>Food Menu</h3>
          </div>
          <div>
            <a href="./addmenu">
              <button className="btn-primary">Add Item</button>
            </a>
          </div>
        </div>
        <div>
          

          {/* Dishes */}
          <div className="container mt-4">
            {loading ? (
              <p>Loading menu...</p>
            ) : dishes.length === 0 ? (
              <p>No menu items available</p>
            ) : (
              <div className="row dish-card-gap" id="dish-list">
                {dishes.map((dish) => (
                  <div className="col-md-4 mb-4" key={dish._id}>
                    <div className="dish-card">
                      <div className="image-wrapper">
                        <img
                          src={dish.image || "https://via.placeholder.com/120"}
                          alt={dish.name}
                          width="100"
                          height="100"
                        />
                      </div>
                      <div className="content">
                        <span className="subtitle">{dish.category?.name||"No Category"}</span>
                        <div className="title-price">
                          <h2 className="title">{dish.name}</h2>
                          <span className="price">{dish.price}</span>
                        </div>
                        <button
                          className="add-btn-edit add-cart"
                          onClick={() => window.location.href = `/addmenu?id=${dish._id}`}
                        >              
                          <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true">
                            <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1.003 1.003 0 0 0 0-1.42l-2.34-2.34a1.003 1.003 0 0 0-1.42 0l-1.83 1.83 3.75 3.75 1.84-1.82z"/>
                          </svg>
                        </button>

                        <button
                          className="add-btn add-cart"
                          onClick={() => handleDelete(dish._id)} // pass the specific dish ID
                        >              
                          <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true">
                            <path d="M16 9v10H8V9h8m-1.5-6h-5l-1 1H5v2h14V4h-4.5l-1-1z"/>
                          </svg>
                        </button>


                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>


        </div>

      </div>
    </>
  );
}

export default Menu;
